import { useEffect, useState } from "react";
import { UserButton } from "@clerk/react";
import { toast } from "sonner";
import { BookOpen } from "lucide-react";
import { AvoraLogo } from "@/components/AvoraLogo";
import { PdfButton } from "@/components/ReportShell";
import { errMsg, fmtPeriod, useApi } from "@/lib/api";

export default function ClientPortal() {
  const api = useApi();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/client/books").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [api]);
  return (
    <div className="min-h-screen bg-[#F6F4EE]" data-testid="client-portal">
      <header className="bg-[#0D2B45] border-b-[3px] border-amber-500">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-5 flex items-center justify-between gap-4">
          <AvoraLogo dark sub="Client portal" />
          <UserButton />
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-5 sm:px-8 py-12 fade-up">
        <div className="small-label">{d?.firm}</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-2" data-testid="client-portal-title">
          {d?.person ? `Welcome, ${d.person}` : "Your statement books"}
        </h1>
        <p className="text-slate-600 mt-3 max-w-xl text-sm sm:text-base">Statement books your advisor has shared with you: your own net worth statement plus the trusts and companies you hold an interest in, as of each month end.</p>
        <div className="panel mt-10 divide-y divide-slate-100" data-testid="client-books-list">
          {d && d.books.length === 0 && <p className="p-6 text-sm text-slate-500" data-testid="client-books-empty">Nothing has been shared with you yet.</p>}
          {(d?.books || []).map((b) => (
            <div key={b.id} className="p-5 sm:p-6 flex flex-wrap items-center justify-between gap-4" data-testid={`client-book-${b.id}`}>
              <div className="flex items-start gap-4">
                <BookOpen className="h-5 w-5 text-amber-600 mt-1 shrink-0" strokeWidth={1.5} />
                <div>
                  <div className="font-serif text-xl">Personal Statement Book · {fmtPeriod(b.period)}</div>
                  <div className="text-xs text-slate-500 mt-1">
                    Shared {new Date(b.created_at).toLocaleDateString()}{b.cover?.advisor ? ` by ${b.cover.advisor}` : ""}
                  </div>
                </div>
              </div>
              <PdfButton api={api} url={`/client/books/${b.id}/pdf`} name={`Personal_Statement_Book_${b.period}.pdf`} testid={`client-book-download-${b.id}`} />
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
